module.exports = __webpack_public_path__ + "static/media/widget-preview.7746bc76.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/widget-preview.png
// module id = 1318
// module chunks = 0